/**
 * Two uppercase letters from a name, for an avatar without a photo: first and
 * last word ("Nina Souza" → "NS"), or the first two letters of a single word.
 * Shared so the roster the Worker stores and the avatars the SPA draws for
 * people not yet on it can never disagree.
 */
export function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? "";
  const second = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : (parts[0]?.[1] ?? "");
  return (first + second).toUpperCase();
}

/** Case- and space-insensitive key for matching one display name to another:
 *  "  victor   ALVES " and "Victor Alves" are the same person's name. */
export function nameKey(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, " ");
}
